var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamonds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/diamonds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diamonds"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9969 22.6002C10.8869 22.6002 9.85689 22.1302 9.08689 21.2902L2.22689 13.7502C1.25689 12.6902 0.956889 10.8202 1.53689 9.51015L4.0969 3.75016C4.7969 2.18016 5.9669 1.41016 7.6869 1.41016H16.2769V2.16016V1.41016C17.9969 1.41016 19.1669 2.17016 19.8669 3.74016L22.4269 9.50016C23.0069 10.8102 22.7169 12.6802 21.7469 13.7402L14.8969 21.2902C14.1469 22.1302 13.1069 22.6002 11.9969 22.6002ZM16.2869 2.90016H7.69689C6.38689 2.90016 5.85689 3.48015 5.47689 4.35015L2.91689 10.1102C2.57689 10.8802 2.77689 12.1102 3.33689 12.7302L10.1969 20.2702C10.6769 20.8002 11.3169 21.0902 11.9969 21.0902C12.6769 21.0902 13.3169 20.8002 13.7969 20.2702L20.6469 12.7202C21.2169 12.0902 21.4169 10.8702 21.0669 10.1002L18.5069 4.34016C18.1269 3.48016 17.5969 2.90016 16.2869 2.90016Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.5 8.75023C3.09 8.75023 2.75 8.41023 2.75 8.00023C2.75 7.59023 3.09 7.25023 3.5 7.25023L20.5 7.24023C20.91 7.24023 21.25 7.58023 21.25 7.99023C21.25 8.40023 20.91 8.74023 20.5 8.74023L3.5 8.75023Z",
    fill: "#B0BECF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamonds);
export default __webpack_public_path__ + "static/media/diamonds.d75c706056f28cce341b509ebe2c1e3e.svg";
export { ForwardRef as ReactComponent };